// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

// Define a service using a base URL and expected endpoints
export const clientNFTsApi = createApi({
  reducerPath: 'clientNFTsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `https://eth-goerli.g.alchemy.com/v2/${process.env.REACT_APP_ALCHEMY_KEY}`,
  }),
  endpoints: (builder) => ({
    getNFTs: builder.query({
      query: (address) => ({
        url: '/getNFTs',
        params: {
          owner: address,
          withMetadata: 'true',
        },
        headers: { accept: 'application/json' },
      }),
    }),
  }),
});

export const { useGetNFTsQuery } = clientNFTsApi;
